import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subscribe-error',
  templateUrl: './subscribe-error.component.html',
  styleUrls: ['./subscribe-error.component.css']
})
export class SubscribeErrorComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
}

